import { ActionTree } from 'vuex';
import RootState from '@/types/store/booking/RootState';
import axios from 'axios';
import AuthState from '@/types/store/auth/AuthState';

const apiUrl = process.env.VUE_APP_API_BASEURL;

const config = {
  withCredentials: false,
};

const actions: ActionTree<AuthState, RootState> = {
  registerUser({ commit, rootState }, { errors, ...user }): Promise<string> {
    const data = { ...user };
    data.birthday = data.birthday.toISOString();
    data.email = data.email.toLowerCase();
    return axios
      .post<any>(`${apiUrl}/v2/auth/register`, data, {
        ...config,
        headers: {
          'Accept-Language': rootState.lang,
        },
      })
      .then(response => {
        if (response.status === 422) {
          const error = new Error('Validation failed');
          // @ts-ignore
          error.response = response;
          throw error;
        }
        if (response.status !== 201) {
          throw new Error('Registration failed!');
        }
        return response;
      })
      .then(({ data }) => data);
  },
  confirmUserRegistration({ commit, rootState }, code): Promise<string> {
    return axios
      .post<any>(
        `${apiUrl}/v2/auth/register/confirmation`,
        { code },
        {
          withCredentials: true,
          headers: {
            'Accept-Language': rootState.lang,
          },
        }
      )
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Registration confirmation failed!');
        }
        return response;
      })
      .then(({ data }) => data);
  },
  requestResetPassword({ commit, rootState }, { email, cellphoneNumber }): Promise<string> {
    const data: { email?: string; cellphoneNumber?: string } = {};
    if (email) {
      data.email = email;
    }
    if (cellphoneNumber) {
      data.cellphoneNumber = cellphoneNumber;
    }
    return axios
      .post<any>(`${apiUrl}/v2/auth/password/request`, data, {
        ...config,
        headers: {
          'Accept-Language': rootState.lang,
        },
      })
      .then(response => {
        if (response.status === 422) {
          const error = new Error('Validation failed');
          // @ts-ignore
          error.response = response;
          throw error;
        }
        if (response.status !== 200) {
          throw new Error('Request password reset failed!');
        }
        return response;
      })
      .then(({ data }) => data);
  },
  resetPassword({ commit, rootState }, { password, code }): Promise<string> {
    return axios
      .post<any>(
        `${apiUrl}/v2/auth/password/change`,
        { password, code },
        {
          ...config,
          headers: {
            'Accept-Language': rootState.lang,
          },
        }
      )
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Reset password failed!');
        }
        return response;
      })
      .then(({ data }) => data);
  },
};

export default actions;
